// extracted by mini-css-extract-plugin
export default {"button":"LinkButton_button__I8vuU","icon":"LinkButton_icon__Q7niP"};